import React from 'react';
import { Search, Calendar, Car } from 'lucide-react';

/**
 * ProcessSteps - Simple 1-2-3 process visualization
 * Shows users how easy it is to book a test drive
 */
const ProcessSteps = () => {
  const steps = [
    {
      number: 1,
      icon: Search,
      title: 'Find Your Dream Ride',
      description: 'Browse amazing cars at friendly dealerships nearby',
      color: 'from-customer-accent to-customer-accent-hover'
    },
    {
      number: 2,
      icon: Calendar,
      title: 'Pick Your Perfect Time',
      description: 'Choose a slot that fits your busy life',
      color: 'from-customer-yellow to-customer-accent'
    },
    {
      number: 3,
      icon: Car,
      title: 'Show Up & Drive!',
      description: 'Walk in, get the keys, and enjoy the ride',
      color: 'from-customer-teal to-customer-teal-hover'
    }
  ];

  return (
    <section className="py-12 lg:py-16 bg-gradient-to-br from-customer-teal-light/30 via-white to-customer-accent-light/30 dark:from-app-bg-tertiary/30 dark:via-app-bg dark:to-app-bg-tertiary/20 customer-friendly">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-app-text-light dark:text-app-text mb-4">
            Easy as 1-2-3!
          </h2>
          <p className="text-lg text-app-text-secondary-light dark:text-app-text-secondary max-w-2xl mx-auto">
            Getting behind the wheel has never been this simple
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={step.number} className="relative">
                {/* Connector Line (desktop only) */}
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-16 left-1/2 w-full h-1 bg-gradient-to-r from-customer-teal/50 to-transparent z-0 rounded-full" />
                )}

                {/* Step Card */}
                <div className="relative bg-white dark:bg-app-bg-secondary rounded-3xl border border-app-border-light/50 dark:border-app-border p-6 text-center hover:border-customer-teal/30 transition-all duration-300 hover:shadow-xl hover:shadow-customer-teal/10 hover:-translate-y-1 z-10">
                  {/* Number Badge */}
                  <div className={`w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-br ${step.color} flex items-center justify-center shadow-lg shadow-customer-accent/20`}>
                    <span className="text-2xl font-bold text-white">{step.number}</span>
                  </div>

                  {/* Icon */}
                  <div className="mb-4">
                    <Icon className="w-8 h-8 mx-auto text-customer-teal" />
                  </div>

                  {/* Title */}
                  <h3 className="text-xl font-bold text-app-text-light dark:text-app-text mb-2">
                    {step.title}
                  </h3>

                  {/* Description */}
                  <p className="text-sm text-app-text-secondary-light dark:text-app-text-secondary">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProcessSteps;
